import React, {StrictMode} from 'react';
import ReactDOM from 'react-dom';
import './assets/css/index.css';
import * as Stores from './stores';
import App from './App';
import * as serviceWorker from './serviceWorker';
import {Provider} from 'mobx-react';
import {HashRouter as Router} from 'react-router-dom';
import {createRoot} from 'react-dom/client';

// After
const container = document.getElementById('root');
const root = createRoot(container!); // createRoot(container!) if you use TypeScript
root.render(
  <StrictMode>
    <Provider {...Stores}>
      <Router>
        <App />
      </Router>
    </Provider>
  </StrictMode>
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
